jQuery(document).ready(function ($) {
  let sum = 0;
  $(".pricing-section:not(.second) .grid .price").each(function () {
    let val = $.trim($(this).text());
    if (val) {
      val = parseFloat(val.replace(/^\$/, ""));
      sum += !isNaN(val) ? val : 0;
    }
  });
  $(".pricing-section:not(.second) .totalprice .price").text("$" + sum);

  let summary = 0;
  $(".pricing-section.second .grid .price").each(function () {
    let val = $.trim($(this).text());
    if (val) {
      val = parseFloat(val.replace(/^\$/, ""));
      summary += !isNaN(val) ? val : 0;
    }
  });
  $(".pricing-section.second .totalprice .price").text("$" + summary);

  window_resize();

  $(window).on("resize", function () {
    window_resize();
  });

  function window_resize() {
    if ($(window).width() < 768) {
      if (
        $(".kids-piercing-slider-list .kids-piercing-slider-item").length > 0
      ) {
        $(".kids-piercing-slider-list .kids-piercing-slider-item").addClass(
          "owl-carousel"
        );
        $(".kids-piercing-slider-list .kids-piercing-slider-item").owlCarousel({
          nav: false,
          dots: false,
          items: 1,
          loop: false,
          autoplay: false,
          margin: 0,
          responsive: {
            0: {
              items: 1,
            },
          },
        });
      }
    } else {
      $(".kids-piercing-slider-list .kids-piercing-slider-item").removeClass(
        "owl-carousel"
      );
      $(".kids-piercing-slider-list .kids-piercing-slider-item").owlCarousel(
        "destroy"
      );
    }
  }

  $(".accordion__summary").click(function () {
    $(this).toggleClass("open");
    var pane = $(this);
    var titleHeight = pane.outerHeight();
    var headerHeight = $("header.header").outerHeight();
    if (pane.hasClass("open")) {
      var $panel = pane.siblings(".accordion__content");
      $("html,body").animate(
        {
          scrollTop: $panel.offset().top - headerHeight - titleHeight,
        },
        500
      );
    }
  });
});
